import React, { useState , useCallback } from "react";
import { Carousel } from "react-bootstrap";
import { FaCommentsDollar } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import { NavLink, useNavigate } from "react-router-dom";
import { trackBannerClick } from "../../utils/datalayerPush";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ClipLoader from "react-spinners/ClipLoader";

const Slider = ({ carouselList }) => {
  // eslint-disable-next-line no-unused-vars
  const [rewind, setRewind] = useState(true);
  const [index, setIndex] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);
  //const [url, setUrl] = useState("");

  const navigate = useNavigate();

  const redirectUrl = useCallback((url) => {
    if (url.slice(0, 5) === "https") {
      window.open(url, '_self', 'noopener,noreferrer');
    } else {
      navigate(`${url}`);
    }
  }, [navigate]);

  const mobileView = useMediaQuery({ query: `(max-width: 991px)` });
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  }; //This avoids recreating the function unnecessarily on each render


  return (
    <div className="Slider">
      {carouselList && carouselList.length > 0 ? (
        <Carousel
          autoplayspeed={1000}
          autoPlay={true}
          rewind={rewind.toString()}
          infinite={rewind.toString()}
          activeIndex={index}
          onSelect={handleSelect}
          controls={carouselList.length > 1 ? true : false}
        >
          {carouselList.map((element, i) => {
            const isFirst = i === 0;
            const brandName = element.url.split("/").pop().replace(/[-_]/g, " ") || "Brand";

            return (
              <Carousel.Item key={i}>
                <div onClick={() => {
                    trackBannerClick(brandName);
                    redirectUrl(element.url);
                  }}>
                  <div
                      style={{
                        position: "relative",
                        width: "100%",
                        minHeight: !imageLoaded[i] ? (mobileView ? "146px" : "230px") : "auto",
                      }}
                    >
                    {!imageLoaded[i] && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          zIndex: 1,
                        }}
                      >
                        <ClipLoader
                          color="#888" 
                          size={40} 
                          // aria-label="Loading Spinner"
                        />
                      </div>
                    )}

                    <LazyLoadImage
                        onClick={() => redirectUrl(element.url)}
                        className="d-block w-100"
                        src={mobileView ? element.mobile_image_url : element.image_url}
                        alt={`Ourshopee ${brandName}`}
                        title={`Ourshopee ${brandName}`}
                        effect={isFirst ? undefined : "blur"}
                        visibleByDefault={isFirst}
                        loading="lazy"
                        afterLoad={() =>
                          setImageLoaded((prev) => ({ ...prev, [i]: true }))
                        }
                        style={{
                          width: "100%",
                          height: "auto",
                          display: "block",
                        }}
                    />
                  </div>
                </div>
              </Carousel.Item>
            );
        })}
        </Carousel>
      ) : (
        <div>
          <div
            style={{
              background: "#D9D9D9",
              position: "relative",
              paddingTop: "120px",
              height: `${mobileView ? "146px" : "430px"}`,
            }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default React.memo(Slider); //React not to re-render this component if the carouselList doesn't change
